module.exports = __webpack_public_path__ + "static/media/item_sli_related_des.1cdb25fa.png";